// @flow
import React from 'react'

const Kitchen = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 23 23">
      <g fill="none" fillRule="evenodd">
        <path d="M-1-1h24v24H-1z" />
        <g stroke="#6E7B8C" strokeLinecap="square">
          <path d="M4.5 8.5h14v10h-14zM4.5 4.5h2M10.5 4.5h2M16.5 4.5h2" />
          <path d="M.5.5h22v22H.5zM8.5 12.5h6" />
        </g>
      </g>
    </svg>
  )
}

export default Kitchen



// WEBPACK FOOTER //
// ./src/components/Icons/Kitchen.js